import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Kettle barbecue, ~0.9 m high: a squashed black kettle sphere with a steel
// rim band and lid handle, on three splayed legs, with a small side shelf.
const BLACK = "#2e2e30";
const STEEL = "#aab2b8";
const PLANK = "#c8975a";

export const bbqGrill = defineModel({
  id: "bbq-grill",
  batchId: "modern",
  name: "BBQ grill",
  tags: ["modern", "outdoor", "garden", "cooking", "grill", "barbecue"],
  summary: "A black kettle barbecue on three legs with a side shelf.",
  description:
    "A kettle barbecue of the Modern Living kit: a matte-black kettle with a " +
    "steel rim band and a lid handle, standing on three splayed legs, with a " +
    "small plank side shelf. About 0.9 m high overall.",
  tiles: { w: 1, h: 1 },
  footprint: 0.8,
  parts(): Part[] {
    const parts: Part[] = [
      // Kettle (bowl + lid as one squashed sphere).
      {
        geometry: new THREE.SphereGeometry(0.28, 12, 8),
        color: BLACK,
        position: [0, 0.6, 0],
        scale: [1, 0.78, 1],
      },
      // Steel rim band at the bowl/lid split.
      {
        geometry: new THREE.CylinderGeometry(0.285, 0.285, 0.04, 12),
        color: STEEL,
        position: [0, 0.62, 0],
      },
      // Lid handle: stem + grip.
      {
        geometry: new THREE.CylinderGeometry(0.018, 0.018, 0.07, 6),
        color: STEEL,
        position: [0, 0.84, 0],
      },
      {
        geometry: new THREE.BoxGeometry(0.14, 0.035, 0.035),
        color: BLACK,
        position: [0, 0.89, 0],
      },
      // Side shelf on a bracket.
      {
        geometry: new THREE.BoxGeometry(0.3, 0.035, 0.34),
        color: PLANK,
        position: [0.4, 0.6, 0],
      },
      {
        geometry: new THREE.BoxGeometry(0.14, 0.035, 0.05),
        color: STEEL,
        position: [0.3, 0.56, 0],
      },
    ];
    // Three splayed legs.
    for (const a of [Math.PI / 2, Math.PI / 2 + (2 * Math.PI) / 3, Math.PI / 2 + (4 * Math.PI) / 3]) {
      parts.push({
        geometry: new THREE.CylinderGeometry(0.02, 0.025, 0.58, 6),
        color: STEEL,
        position: [Math.cos(a) * 0.17, 0.27, Math.sin(a) * 0.17],
        rotation: [Math.sin(a) * 0.28, 0, -Math.cos(a) * 0.28],
      });
    }
    return parts;
  },
  animations: [],
});
